<template>
  <el-tabs class="common-tabs" v-model="activeName" @tab-click="handleTabClick">
    <el-tab-pane label="数据上传" name="tabUpload" v-if="userMenu.indexOf('数据上传') >= 0"></el-tab-pane>
    <el-tab-pane label="数据下载" name="tabDown" v-if="userMenu.indexOf('数据下载') >= 0"></el-tab-pane>
    <el-tab-pane label="系统管理" name="tabSystem" v-if="userMenu.indexOf('系统管理') >= 0">
      <div id="mySystemMessager" v-if="userMenu.indexOf('系统管理') >= 0">
        <div class="allBody">
          <!-- <nav class="allTop">
        <img src="../../../assets/home01.png" width="100%" height="60"/>
        <div>系统管理</div>
      </nav> -->
          <div class="sytmgDiv">
            <div>
              <span v-if="userMenu.indexOf(item.name) >= 0" @click="toUrl(item)" :class="parseInt(menuNum) === parseInt(item.id) ? 'onUhSpan' : ''" :key="index" v-for="(item, index) in systemMenu">{{ item.name }}</span>
              <!-- <span @click="toUrl(item)" :class="parseInt(menuNum) === parseInt(item.id) ? 'onUhSpan' : ''" :key="index" v-for="(item, index) in systemMenu">{{ item.name }}</span> -->
            </div>
          </div>
          <router-view v-if="userMenu.indexOf('数据规则校验') >= 0 || userMenu.indexOf('权限配置') >= 0 || userMenu.indexOf('api Gate管理') >= 0 || userMenu.indexOf('日志管理') >= 0"></router-view>
          <!-- <router-view  v-if="userMenu.indexOf('数据规则校验') >= 0 || userMenu.indexOf('权限配置') >= 0 || userMenu.indexOf('api Gate管理') >= 0"></router-view> -->
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
let timeMenu
export default {
  name: 'mySystemMessager',
  data () {
    return {
      activeName: 'tabSystem',
      userMenu: this.$userMenu,
      systemMenu: [
        {
          id: 1,
          name: '数据规则校验',
          url: 'mySystemList',
          activeUrl: 'mySystemListmyValidationDetail'
        },
        {
          id: 2,
          name: '权限配置',
          url: 'mySupersuProList',
          activeUrl: 'mySupersuProListmySupersuPro'
        },
        {
          id: 3,
          name: 'api Gate管理',
          url: 'myAPIGateList',
          activeUrl: 'myAPIGateListmyAPIGate'
        },
        {
          id: 4,
          name: '日志管理',
          url: 'myLogList',
          activeUrl: 'myLogListmyLogHomeDetail'
        }
      ],
      menuNum: 1
    }
  },
  created () {
    timeMenu = setInterval(p => {
      if ('mySystemListmyValidationDetail'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 1
      } else if ('mySupersuProListmySupersuPro'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 2
      } else if ('myAPIGateListmyAPIGate'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 3
      } else if ('myLogListmyLogHomeDetail'.indexOf(this.$route.name) >= 0) {
        this.menuNum = 4
      }
    }, 100)
  },
  destroyed () {
    clearInterval(timeMenu)
  },
  mounted () {
  },
  methods: {
    handleTabClick () {
      if (this.activeName === 'tabUpload') {
        this.$router.push({ name: 'index' })
      } else if (this.activeName === 'tabDown') {
        this.$router.push({ name: 'myDnload' })
      }
    },
    toUrl (item) {
      this.menuNum = item.id
      this.$router.push({
        name: item.url
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/mySystemMessager.vue